import { CopyAndNotify, GASendEvent } from "./bookmarkUtils";
import {
  ShareFacebookButton,
  ShareGMailButton,
  ShareTelegramButton,
  ShareViberButton,
} from "./ToolButtons";

export function ShareBookmark({
  copyClipboard = "Copy to clipboard",
  shareFacebookText = "Share Facebook",
  sendGMailText = "Send Email",
  bookmarkId,
  user,
}) {
  // INCLUDE the current hash route so recipients land on the same page (e.g. #/assets)
  const { origin, pathname, hash } = window.location;
  const bookmarkURL = `${origin}${pathname}?bookmark=${encodeURIComponent(
    bookmarkId
  )}${hash || ""}`;

  const copyToClipboardHandler = (e) => {
    e.stopPropagation();
    e.preventDefault();
    CopyAndNotify(e, bookmarkURL);
    GASendEvent("Bookmarks", "Share Bookmark", "Clipboard");
  };

  return (
    <div className="form-group">
      <label htmlFor="bookmarkURL">URL</label>
      <div className="input-group">
        <input
          type="text"
          autoFocus
          className="form-control"
          id="bookmarkURL"
          name="bookmarkURL"
          defaultValue={bookmarkURL}
          onClick={copyToClipboardHandler}
          // readOnly
        />
        <span className="input-group-btn input-group-append">
          <button
            className="btn btn-success"
            type="button"
            title={copyClipboard}
            onClick={copyToClipboardHandler}
          >
            <i className="lui-icon lui-icon--copy" />
          </button>
        </span>

        {user && user.UserDirectory === "FACEBOOK" && (
          <span className="input-group-btn input-group-append">
            <ShareFacebookButton url={bookmarkURL} title={shareFacebookText} />
          </span>
        )}

        {user && user.UserDirectory === "GOOGLE" && (
          <span className="input-group-btn input-group-append">
            <ShareGMailButton
              url={bookmarkURL}
              subject="Subject"
              title={sendGMailText}
            />
          </span>
        )}

        <span className="input-group-btn input-group-append">
          <ShareTelegramButton url={bookmarkURL} />
        </span>

        <span className="input-group-btn input-group-append">
          <ShareViberButton url={bookmarkURL} />
        </span>
      </div>
    </div>
  );
}
